import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://cfnrwoajlbbvhxjpuizp.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNmbnJ3b2FqbGJidmh4anB1aXpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU4Nzk3MDUsImV4cCI6MjA4MTQ1NTcwNX0.w6O6CltrT-aoAri8Bs5IO1ohUYhzx2ePmDQLCYDctz8';

// Service role key — Supabase Dashboard → Settings → API → service_role key
const SUPABASE_SERVICE_KEY = process.env.REACT_APP_SUPABASE_SERVICE_KEY || '';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Admin user creation via raw fetch (supabase-js blocks service key in browser)
export async function adminCreateUser(email, password) {
  if (!SUPABASE_SERVICE_KEY) {
    throw new Error('Service key konfiqurasiya edilməyib');
  }
  const res = await fetch(`${SUPABASE_URL}/auth/v1/admin/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${SUPABASE_SERVICE_KEY}`,
      'apikey': SUPABASE_SERVICE_KEY,
    },
    body: JSON.stringify({ email, password, email_confirm: true }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.error_description || 'İstifadəçi yaradılmadı');
  return data; // { id, email, ... }
}
